import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { UserService } from './user.service';
import {environment} from '../../../environments/environment';

@Injectable()
export class ResetPasswordGuardService implements CanActivate {
  constructor(private authService: AuthService, private userService: UserService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return new Observable<boolean>(observer => {
      this.authService.validateResetToken({url: window.location.href}).subscribe(
        response => {
          if (response.failure) {
            window.location.href = `${environment.my_journey_url} + /expired-link`;

            observer.next(false);
          } else {
            this.userService.localUserId = response.id;
            observer.next(true);
          }
        },
        () => {
          window.location.href = `${environment.my_journey_url} + /expired-link`;
          observer.next(false);
        }
      );
    });
  }
}
